import { useEffect, useRef } from 'react';
import { AvField } from 'availity-reactstrap-validation';
import { Col, Label } from 'reactstrap';

import useVatNumberCheck from 'src/modules/3rd-party-management/hooks/useVatNumberCheck';
import VatNumberCheckFeedback from 'src/modules/3rd-party-management/components/VatNumberCheckFeedback';

const VatNumberField = ({
    field,
    value,
    t,
    onChange,
}) => {
    const fieldId = field.key.replace(/\./g, '_');

    const { status, details, checkVatNumber, reset } = useVatNumberCheck();

    const isFocusedRef = useRef(false);

    // Values that arrive while the field is untouched come from the AI lookup,
    // so they are verified right away instead of waiting for a blur.
    useEffect(() => {
        if (isFocusedRef.current) return;

        if (!value) {
            reset();

            return;
        }

        checkVatNumber(value);
    }, [value, checkVatNumber, reset]);

    return (
        <Col lg="3" md="6" sm="12" className="mb-4">
            <Label for={fieldId}>
                {t(field.labelKey)}:{field.required && <span className="text-danger"> *</span>}
            </Label>
            <AvField
                id={fieldId}
                name={field.key}
                type="text"
                className="form-control"
                validate={{
                    required: {
                        value: !!field.required,
                    },
                }}
                errorMessage={t('This field cannot be blank')}
                value={value || ''}
                onFocus={() => {
                    isFocusedRef.current = true;
                }}
                onChange={(event) => {
                    reset();
                    onChange(field.key, event.target.value);
                }}
                onBlur={(event) => {
                    isFocusedRef.current = false;
                    checkVatNumber(event.target.value);
                }}
            />

            <VatNumberCheckFeedback
                status={status}
                details={details}
            />
        </Col>
    );
};

export default VatNumberField;
